import { render, staticRenderFns } from "./BuyHistoryModal.vue?vue&type=template&id=410ee4a6&"
import script from "./BuyHistoryModal.vue?vue&type=script&lang=js&"
export * from "./BuyHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyHistoryModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports